import { CLIENT_SERVER_ERROR_TRACKING } from '../enums/trackingEnums';

export const ANALYTICS_ACTION = 'ANALYTICS_ACTION';
export const LINK_TRACK_ANALYTICS_ACTION = 'LINK_TRACK_ANALYTICS_ACTION';
export const INVIEW_TRACK_ANALYTICS_ACTION = 'INVIEW_TRACK_ANALYTICS_ACTION';
export const CLICKSTREAM_ACTION = "CLICKSTREAM_ACTION";

export function analyticsAction(e, componentName) {
    return {
        type: ANALYTICS_ACTION,
        meta: {
            event: e,
            componentName: componentName
        }
    };
}

export function clientServerErrorTracking(errorSlug) {
    const pageId = _.get(window, 'utag.data.page_id', 'NO_PAGE_ID');

    return {
        type: CLIENT_SERVER_ERROR_TRACKING,
        payload: {
            errorTag: `ERROR-_-${errorSlug}-_-${pageId}`
        }
    };
}

export function linkTrackAnalyticsAction(e, componentName) {
    return {
        type: LINK_TRACK_ANALYTICS_ACTION,
        meta: {
            event: e,
            componentName: componentName
        }
    };
}

export function inViewTrackAnalyticsAction(e, element, componentName) {
    return {
        type: INVIEW_TRACK_ANALYTICS_ACTION,
        meta: {
            event: e,
            element: element,
            componentName: componentName
        }
    };
}

/**
 * Action to fire off a clickstream event to
 *  Groundhog or some other receptor
 */
export function clickstreamAction(data) {
    return {
        type: CLICKSTREAM_ACTION,
        payload: data
    };
}
